import { FC } from "react";
import { Stack } from "@mui/material";
import { BillingExplorerWidgetSetupContentCosts } from "../components/BillingExplorerWidgetSetupContentCosts";
import { useAppSelector } from "@/store/hooks";
import { billingExplorerSetupPropertyByKeySelector } from "@/store/dashboards/selectors/setups/billing-explorer/billingExplorerSetupPropertyByKeySelector";
import { billingExplorerSetupHasAggregationSelector } from "@/store/dashboards/selectors/setups/billing-explorer/billingExplorerSetupHasAggregationSelector";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { billingExplorerWidgetSetupLoadingSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupLoadingSelector";
import { BillingExplorerWidgetHighChart } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/billing-explorer/components/high-chart-view/BillingExplorerWidgetHighChart";
import { billingExplorerWidgetSetupDataSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupDataSelector";

export const BillingExplorerWidgetSetupChartView: FC = () => {
  const data = useAppSelector(billingExplorerWidgetSetupDataSelector);
  const chartData = data?.data;
  const forecastedCosts = data?.forecasted_costs;
  const visualization = useAppSelector(
    billingExplorerSetupPropertyByKeySelector("visualization"),
  );

  const loading = useAppSelector(billingExplorerWidgetSetupLoadingSelector);
  const hasAggregations = useAppSelector(
    billingExplorerSetupHasAggregationSelector,
  );

  const quarterStartMonth = useAppSelector(
    organisationQuarterStartMonthSelector,
  );

  const dates = useAppSelector(
    billingExplorerSetupPropertyByKeySelector("dates"),
  );

  const frequency = useAppSelector(
    billingExplorerSetupPropertyByKeySelector("frequency"),
  );

  if (!visualization) {
    return;
  }

  return (
    <Stack flex={1} p={2}>
      <BillingExplorerWidgetSetupContentCosts />

      <BillingExplorerWidgetHighChart
        dates={dates}
        data={chartData}
        loading={loading}
        frequency={frequency}
        visualization={visualization}
        forecastedCosts={forecastedCosts}
        hasAggregations={hasAggregations}
        quarterStartMonth={quarterStartMonth}
      />
    </Stack>
  );
};
